class PopupController {
    /**
     * @type {Popup|null}
     */
    popup = null;

    constructor() {
        this.init();
    }

    init() {
        this.setup();
    }

    setup() {
    }

    /**
     * @param {Popup} popup
     */
    setPopup(popup) {
        this.popup = popup;
    }

    /**
     * @return {Popup}
     */
    getPopup() {
        return this.popup;
    }
}

export default new PopupController();
